import type { RelationManagerResource } from '@/features/relation-manager/api/relation-manager'
import type { User } from '@/features/iam/users/User'
import type { RelationManagerProps } from '@/features/relation-manager/RelationManager'

export function mapRelationshipManagerResourceToProps({
  rm,
  user,
}: {
  rm: RelationManagerResource
  user: User
}): RelationManagerProps {
  return {
    id: user.id,
    meetingLink: rm.meetingLink,
    isAvailable: rm.isAvailable,
    firstName: user.givenName,
    lastName: user.familyName,
    fullName: user.displayName,
    avatarUrl: user.avatarUrl,
    email: user.email,
    phoneNumber: user.phone,
  }
}
